import {
  CREATE_MISSION_CONDITIONS_FIXED_CACHE_KEY,
  CREATE_MISSION_FIXED_CACHE_KEY
} from '@bo-constants/missions';
import {
  useCreateMissionConditionPropertiesMutation,
  useCreateMissionConditionsMutation,
  useCreateMissionMutation
} from '@bo-services/promotionsApi';
import { useEffect, useState } from 'react';
import { CreateMissionStepSummary } from '@bo-components/missions/CreateMissionStepSummary';
import { FormActionButtons } from '@library/components/buttons';
import type { MissionConditionPropertyInput } from '@library/types/missions';
import { MissionConditionsFormInputs } from '@bo-components/missions/MissionConditionsFormInputs';
import { useNavigate } from 'react-router-dom';
import { useSteps } from '@library/components/progress/Steps';

export const MissionConditionsForm = () => {
  const [inputs, setInputs] = useState<MissionConditionPropertyInput[]>([]);
  const [createMissionConditionProperties, { isSuccess }] =
    useCreateMissionConditionPropertiesMutation();
  const [, { data: createdMission }] = useCreateMissionMutation({
    fixedCacheKey: CREATE_MISSION_FIXED_CACHE_KEY
  });
  const [, { data: createdConditions }] = useCreateMissionConditionsMutation({
    fixedCacheKey: CREATE_MISSION_CONDITIONS_FIXED_CACHE_KEY
  });
  const navigate = useNavigate();
  const { setCurrentStep } = useSteps();

  const handleBack = () => {
    setCurrentStep('events');
  };

  const handleSaveAndContinue = async () => {
    const payload = {
      challenge_id: createdMission?.challenge.id,
      challenge_condition_properties: inputs
    };

    await createMissionConditionProperties(payload);
  };

  const details = createdMission?.challenge;
  const events = createdConditions?.challenge_conditions;

  const handleConditionPropertyChange = (
    input: MissionConditionPropertyInput,
    index: number
  ) => {
    const newInputs = [...inputs];
    newInputs[index] = input;
    setInputs(newInputs);
  };

  useEffect(() => {
    if (isSuccess && createdMission) {
      navigate(`/missions/${createdMission.challenge.id}`);
    }
  }, [isSuccess, createdMission, navigate]);

  return (
    <>
      <CreateMissionStepSummary mission={details} />
      <div className="flex min-h-[30vh] flex-col gap-4">
        {events?.map((event, index) => (
          <MissionConditionsFormInputs
            key={event.event_definition_id}
            event={event}
            index={index}
            onChange={handleConditionPropertyChange}
          />
        ))}
      </div>
      <FormActionButtons
        primary={{ onClick: handleSaveAndContinue, label: 'Save Challenge' }}
        secondary={{ onClick: handleBack, label: 'Back' }}
      />
    </>
  );
};
